// extracted by mini-css-extract-plugin
export default {"content":"style_content__SMUid","btn":"style_btn__kUvDQ"};